/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IGetHouseOfferHistoryDesktopResponse } from '../../../repositories/valuation-offer-history/v1/get-house-offer-history-desktop';
import { IOfferHistoryData, IOffer } from '../types';
import { prepareOffers } from './prepareOffers';
import { prepareRoomsFilters, prepareStatusFilters } from './prepareFilters';
import { prepareBlockTitle } from './prepareBlockTitle';

export const prepareOfferHistory = (res: IGetHouseOfferHistoryDesktopResponse): IOfferHistoryData => {
  const offers: IOffer[] = prepareOffers(res.offers);
  const roomsFilters = prepareRoomsFilters(res.roomCounts);
  const statusFilters = prepareStatusFilters(res.statusCounts);
  const blockTitle = prepareBlockTitle(res.statusCounts);

  return {
    offers,
    roomsFilters,
    statusFilters,
    blockTitle,
    totalCount: res.totalCount,
  };
};
